// extracted by mini-css-extract-plugin
export var $animation_name = "ProductVariantSelector-module--$animation_name--6758f";
export var ProductVariant = "ProductVariantSelector-module--ProductVariant--b0724";
export var ProductVariant__title = "ProductVariantSelector-module--ProductVariant__title--9c2b4";
export var Variant = "ProductVariantSelector-module--Variant--ae4c2";
export var Variant___active = "ProductVariantSelector-module--Variant___active--def67";
export var Variant__bullet = "ProductVariantSelector-module--Variant__bullet--58f44";
export var Variant__price = "ProductVariantSelector-module--Variant__price--1f926";
export var Variant__title = "ProductVariantSelector-module--Variant__title--d9e35";
export var Variants = "ProductVariantSelector-module--Variants--ea9b4";